export function generatePassword(pLength = 16) {
    var keyListAlpha = 'abcdefghijklmnopqrstuvwxyz',
        keyListInt = '123456789',
        keyListSpec = '!@#_',
        password = '';
    var len = Math.ceil(pLength / 2);
    len = len - 1;
    var lenSpec = pLength - 2 * len;

    for (let i = 0; i < len; i++) {
        password += keyListAlpha.charAt(Math.floor(Math.random() * keyListAlpha.length));
        password += keyListInt.charAt(Math.floor(Math.random() * keyListInt.length));
    }

    for (let i = 0; i < lenSpec; i++) password += keyListSpec.charAt(Math.floor(Math.random() * keyListSpec.length));

    password = password
        .split('')
        .sort(function () {
            return 0.5 - Math.random();
        })
        .join('');

    return password;
}

export default {
    generatePassword
}